import { Link, LinkOptions } from "@/components/link";
import { PATH_PAYROLL_SPLIT } from "@/constants";
import { InspectIcon } from "lucide-react";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { generatePath } from "react-router-dom";
import { usePayrollParams } from "../hooks/usePayrollParams";

interface PayrollSplitLinkProps {
  options?: LinkOptions;
}

export const PayrollSplitLink = memo(({ options }: PayrollSplitLinkProps) => {
  const { t } = useTranslation();
  const { payrollId } = usePayrollParams();

  return (
    <Link
      to={generatePath(PATH_PAYROLL_SPLIT, {
        payrollId,
      })}
      options={options}
    >
      <InspectIcon className="w-5 h-5 mr-1" />
      {t("payrolls.splitPayroll.link")}
    </Link>
  );
});
